import { render, staticRenderFns } from "./Squad.vue?vue&type=template&id=abfbea96&scoped=true"
import script from "./Squad.vue?vue&type=script&lang=js"
export * from "./Squad.vue?vue&type=script&lang=js"
import style0 from "./Squad.vue?vue&type=style&index=0&id=abfbea96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfbea96",
  null
  
)

export default component.exports